export default __webpack_public_path__ + "static/media/1962.c22147b9.png";